export default __webpack_public_path__ + "static/media/FUERZA_LABORAL_BANNER_RIGHT_IMG.566d31e3.png";